import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { BrowserRouter } from 'react-router-dom';
import keycloak from './keycloak';
import 'bootstrap/dist/css/bootstrap.min.css';
import './i18n';
import { Spinner } from 'reactstrap';

const root = ReactDOM.createRoot(document.getElementById('root'));

const initOptions = {
    onLoad: 'check-sso',
    pkceMethod: 'S256',
};

root.render(
    <ReactKeycloakProvider authClient={keycloak} initOptions={initOptions}>
        <BrowserRouter>
            <React.StrictMode>
                <Suspense fallback={<div className="text-center mt-5"><Spinner color="primary" /></div>}>
                    <App />
                </Suspense>
            </React.StrictMode>
        </BrowserRouter>
    </ReactKeycloakProvider>
);

// Register Service Worker for PWA and Web Share Target
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
            .then(reg => {
                console.log('[PWA] Service Worker registered with scope:', reg.scope);
            })
            .catch(err => {
                console.warn('[PWA] Service Worker registration failed:', err);
            });
    });
}
